import { render, staticRenderFns } from "./customerNumber.vue?vue&type=template&id=15f4e55c&scoped=true"
import script from "./customerNumber.vue?vue&type=script&lang=js"
export * from "./customerNumber.vue?vue&type=script&lang=js"
import style0 from "./customerNumber.vue?vue&type=style&index=0&id=15f4e55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4e55c",
  null
  
)

export default component.exports